var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRectLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 1440,
    height: 550,
    preserveAspectRatio: "none",
    viewBox: "0 0 1440 550",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(\"#SvgjsMask2083\")",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 550,
    x: 0,
    y: 0,
    fill: "url(#SvgjsLinearGradient2084)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 550L603 0L684 0L134 550z",
    fill: "url(#SvgjsLinearGradient2085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.8 550L892.8 0L1188.3 0L638.3 550z",
    fill: "url(#SvgjsLinearGradient2085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.6 550L1193.6 0L1483.1 0L933.1 550z",
    fill: "url(#SvgjsLinearGradient2085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1401 550L851 0L479 0L1029 550z",
    fill: "url(#SvgjsLinearGradient2086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.2 550L568.2 0L236.70000000000005 0L786.7 550z",
    fill: "url(#SvgjsLinearGradient2086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.4 550L242.39999999999998 0L32.39999999999998 0L582.4 550z",
    fill: "url(#SvgjsLinearGradient2086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.5456469072683 550L1440 89.54564690726835L1440 550z",
    fill: "url(#SvgjsLinearGradient2085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 550L460.45435309273165 550L 0 89.54564690726835z",
    fill: "url(#SvgjsLinearGradient2086)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "SvgjsMask2083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 550,
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    gradientUnits: "userSpaceOnUse",
    id: "SvgjsLinearGradient2084"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0e2a47",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(0, 0, 0, 1)",
    offset: 0.51
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "SvgjsLinearGradient2085"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(0, 37, 110, 1)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    stopColor: "rgba(0, 37, 110, 1)",
    offset: 0.66
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "SvgjsLinearGradient2086"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(0, 37, 110, 1)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    stopColor: "rgba(0, 37, 110, 1)",
    offset: 0.66
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectLight);
export default __webpack_public_path__ + "static/media/rect-light.c7184bdcdcbc0a9c7a4b75b8121d6a54.svg";
export { ForwardRef as ReactComponent };